import { AbhaLoginType } from './iabha-info';

export const ABHA_NUMBER_PATTERN = /^(?:[0-9]{14}|[0-9]{2}-[0-9]{4}-[0-9]{4}-[0-9]{4})$/;
export const ABHA_ADDRESS_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._]{2,}@[A-Za-z]+$/;

// One field takes either an ABHA number or an ABHA address.
export const ABHA_LOGIN_ID_PATTERN = new RegExp(`${ABHA_NUMBER_PATTERN.source}|${ABHA_ADDRESS_PATTERN.source}`);

// An ABHA address always carries a handle such as @abdm or @sbx.
export function resolveAbhaLoginType(loginId: string): AbhaLoginType {
  return loginId.includes('@') ? 'abha-address' : 'abha-number';
}
